var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9583 5.91669H31.4583C30.5602 5.91669 29.8333 6.64362 29.8333 7.54169C29.8333 8.43975 30.5602 9.16669 31.4583 9.16669H37.9583C38.8564 9.16669 39.5833 8.43975 39.5833 7.54169C39.5833 6.64362 38.8564 5.91669 37.9583 5.91669Z",
    fill: "#922D4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0.25H19C15.2783 0.25 12.25 3.2783 12.25 7V59C12.25 62.7217 15.2783 65.75 19 65.75H45C48.7217 65.75 51.75 62.7217 51.75 59V7C51.75 3.2783 48.7217 0.25 45 0.25ZM48 59C48 60.657 46.657 62 45 62H19C17.343 62 16 60.657 16 59V7C16 5.34295 17.343 4 19 4H45C46.657 4 48 5.34295 48 7V59Z",
    fill: "#922D4E",
    stroke: "#922D4E",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60.0833C33.7949 60.0833 35.25 58.6282 35.25 56.8333C35.25 55.0383 33.7949 53.5833 32 53.5833C30.2051 53.5833 28.75 55.0383 28.75 56.8333C28.75 58.6282 30.2051 60.0833 32 60.0833Z",
    fill: "#922D4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0417 9.16669C26.9392 9.16669 27.6667 8.43915 27.6667 7.54169C27.6667 6.64422 26.9392 5.91669 26.0417 5.91669C25.1442 5.91669 24.4167 6.64422 24.4167 7.54169C24.4167 8.43915 25.1442 9.16669 26.0417 9.16669Z",
    fill: "#922D4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.02d404b187481e92e1327e2d6960ae40.svg";
export { ForwardRef as ReactComponent };